module.exports = {
  mounted () {
    // eslint-disable-next-line
    if (typeof $(this.$el).foundation === 'function') $(this.$el).foundation();
  },
  destroyed () {
    // eslint-disable-next-line
    if (typeof $(this.$el).foundation.destroy === 'function') $(this.$el).foundation.destroy();
  }
};
